export default __webpack_public_path__ + "static/background-mob-35b798d7f2707556e142450b4b48bec1.jpg";